import { getMessage } from './IntlMessages'

export default {
  MULTIPLICATION: { value: 'MULTIPLICATION', description: getMessage('forecast.soy.area.type.multiplication') },
  RESERVED: { value: 'RESERVED', description: getMessage('forecast.soy.area.type.reserved') },
  CERTIFIED: { value: 'CERTIFIED', description: getMessage('forecast.soy.area.type.certified') },
  ILLEGAL: { value: 'ILLEGAL', description: getMessage('forecast.soy.area.type.illegal') },
  REPLANT: { value: 'REPLANT', description: getMessage('forecast.soy.area.type.replant') },
  REFUGE: { value: 'REFUGE', description: getMessage('forecast.soy.area.type.refuge') }
}
